import type { ReactElement } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import { StyledOpportunitySpottedPlaceholderLoader } from "./styles";

const OpportunitySpottedLoadingState = (): ReactElement => {
    return (
        <Stack
            gap="4px"
            height="100%"
        >
            <StyledOpportunitySpottedPlaceholderLoader
                width="100%"
                height="14px"
            />
            <StyledOpportunitySpottedPlaceholderLoader
                width="50%"
                height="14px"
            />
        </Stack>
    );
};

export default OpportunitySpottedLoadingState;
